if (!customElements.get('algolia-product-slider')) {  
  customElements.define(
    'algolia-product-slider',
    class AlgoliaProductSlider extends HTMLElement {
      constructor() {
        super();
        this.isInit = false;
        this.algoliaClient = false;
        this.indexPrefix = this.dataset.prefix;
        this.currentIndex = `${this.indexPrefix}products${getSuffix()}`;
        this.productsPerPage = 150;
        this.collectionHandle = this.dataset.collectionHandle;
      }

      connectedCallback() {    
        if (this.isInit) return;     
        
        if (window.algoliaIsLoaded) {
          this.init();
          return;
        }       
        
        window.addEventListener('algolia:script-loaded', () => {
          this.init();
        });
      }

      init() {
        if (this.isInit) return;     
        this.isInit = true;

        this.collectionHandle = this.dataset.collectionHandle;
        this.algoliaClient = window.algoliasearch('B8RIKEI9OC', '307ccfad891594b0e4b982aa6a862676');
        this.algoliaClient.initIndex(this.currentIndex);
        this.fetchFilteredResults();
      }

      async fetchFilteredResults() {
        await this.algoliaClient.multipleQueries([{
          indexName: this.currentIndex,
          clickAnalytics: true,
          params: {
            facets: '*',
            filters: `collections:${this.collectionHandle}`,
            hitsPerPage: this.productsPerPage,
            page: 0,
            query: '',
            ruleContexts: this.collectionHandle
          }
        }], 1, false).then((res) => {
          window.dispatchEvent(new CustomEvent('algolia:setData', { 
            detail: { 
              queryID: res.results[0]?.queryID,
              index: this.currentIndex
            } 
          }));

          const hits = res.results[0]?.hits || [];
          this.renderHits(hits.slice(0, 12));
        });
      }

      renderHits(hits) {
        window.dispatchEvent(new CustomEvent('algolia:productsViewed', { 
          detail: { 
            products: hits
          } 
        }));
        const parent = this.parentNode;
        if (!parent) return;
      
        const fragment = document.createDocumentFragment();
      
        hits.forEach(product => {
          const loader = document.createElement('div');      
          for (const attr of this.attributes) {
            loader.setAttribute(attr.name, attr.value);
          }
          loader.className = this.className;
      
          loader.innerHTML = `
            <intersection-loader
              data-object-id="${product.objectID}"
              data-position="${product.position}"
              data-section-id="product-tile"
              data-url="${Shopify.routes.root}${this.collectionHandle ? `collections/${this.collectionHandle}/` : ''}products/${product.handle}"
            >
              <div class="loading animate-pulse w-full aspect-[4/5] bg-mercury shadow rounded-lg relative flex items-center justify-center">
                <div class="loader !bg-transparent">
                  <span class="block w-12 h-12">
                    <svg class="animate-spin -ml-1 mr-3 h-full w-full text-primaryBrand" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </span>
                </div>
              </div>
            </intersection-loader>
          `;
          fragment.appendChild(loader);
        });
      
        // Replace the custom element with the document fragment
        parent.replaceChild(fragment, this);
      }      
      
    }
  );
}
